import Createhedge from "../components/hedge/createhedge/createhedge";

const CreateHedge = () => {
  return (
    <>
      <Createhedge />
    </>
  );
};

export default CreateHedge;
